var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pin-page h-100 text-center"},[_c('b-container',{staticClass:"h-100",attrs:{"fluid":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }